export default [{
    path: '/outside-introduce',
    name: 'outside-introduce',
    meta: {
        title: "活动介绍",
        requiresAuth: false,
    },
    component: () =>
        import ( /* webpackChunkName: 'outside-introduce' */ './common-outside-introduce/index.vue')
}, {
    path: '/outside-signup',
    name: 'outside-signup',
    meta: {
        title: "活动购买",
        requiresAuth: false,
    },
    component: () =>
        import ( /* webpackChunkName: 'outside-signup' */ './common-outside-signup/index.vue')
}, {
    path: '/outside-newsuccess',
    name: 'outside-newsuccess',
    meta: {
        title: "购买成功",
        requiresAuth: false,
    },
    component: () =>
        import ( /* webpackChunkName: 'outside-success' */ './common-outside-newsuccess/index.vue')
}]